import React from 'react';
import { Reveal } from './Reveal';
type Review = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const reviews: Review[] = [{
  initials: 'MF',
  quote: 'J’ai ouvert le Tome 4 un mardi soir et le jeudi quelque chose s’était libéré en moi que je portais depuis 20 ans. Les modèles de libération l’ont rendu possible. Je me sens enfin moi-même.',
  name: 'Michelle F.',
  role: 'Genève, Suisse · Chercheuse Spirituelle'
}, {
  initials: 'NG',
  quote: 'Le Bonus Génogramme de Solution a tout changé. Cartographier trois générations sur une seule page a été la chose la plus clarifiante que j’aie jamais faite. Des schémas que j’ai vécus pendant 40 ans ont soudainement eu un sens complet.',
  name: 'Nicole G.',
  role: 'Montréal, Canada · Étudiante en Psychologie'
}, {
  initials: 'AL',
  quote: 'J’ai utilisé le guide avec mon partenaire. Nous avons cartographié nos deux systèmes familiaux. Pour la première fois nous avons arrêté de nous battre l’un contre l’autre et commencé à guérir ensemble. Ce système fonctionne vraiment.',
  name: 'Amélie L.',
  role: 'Marseille, France · Coach Holistique'
}];
export function Reviews() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-198" data-mp="2hf9arkfs27x5">
      <div className="mx-auto max-w-6xl" data-id="element-199" data-mp="2dd5yitlaazat">
        <Reveal className="text-center" data-id="element-200" data-mp="2de7i5mgd8u45">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-201" data-mp="3a35gfenbra62">
            ⭐ Plus de <span className="text-sage" data-id="element-202" data-mp="3a59hlotu9v2n">résultats réels</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-203" data-mp="355dgbxcj0hqs">4.9/5 · Des centaines brisent déjà le cycle.</p>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-204" data-mp="30bspqqd9iq1m">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.05} className="h-full" data-id="element-205" data-mp="2wbi6wd4dg55c" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-7 shadow-premium" data-id="element-206" data-mp="3sug47mxr76tq">
                <div className="text-amber" data-id="element-207" data-mp="3o1mx4setbmeh">★★★★★</div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-208" data-mp="1m54en8hoa47p">
                  «&nbsp;{review.quote}&nbsp;»
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-209" data-mp="1r6bkv3462vc9">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-210" data-mp="1cf1k33uwki79">
                    {review.initials}
                  </span>
                  <span data-id="element-211" data-mp="13dblne2lsizz">
                    <span className="block font-bold text-navy" data-id="element-212" data-mp="13h9746cnlmn1">{review.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-213" data-mp="18fapsq663jxz">{review.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}